import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE ,defaultCurrency,API_URLBLAZEOLD} = environment;
@Injectable({
  providedIn: 'root'
})
export class ExchangeRateService {
    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    //Add new exchange rate slab
    addExchangeRateSlab(exchangeSlabs: any) {
        const url = `${API_URLBLAZE}/product/currency-conversion-rate`;
        return this.http.post(url, exchangeSlabs).pipe(catchError(this.handleError()));
    }

    //Get exchange rate list
    getExchangeRateList(countryName:String, page_size:number,page_no:number) {
      var url = "";
      var filter = "";
      if(countryName != "" && countryName != null){
        filter = filter+`&code=${countryName}`
      }
      url = `${API_URLBLAZE}/product/currency-conversion-rate/countries?page_size=${page_size}&page_no=${page_no}`+filter;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

     //Get exchange rate Dropdown
     getExchangeRateDropDown(countryName:String, page_size:any,page_no:number) {
      var url = "";
      var filter = "";
      if(countryName != "" && countryName != null){
        filter = filter+`&code=${countryName}`
      }
      url = `${API_URLBLAZE}/product/currency-conversion-rate/countries?page_size=${page_size}&page_no=${page_no}`+filter;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get exchange rate by currency
    getExchangeSlabByCurrency(currency:any) {
      const url = `${API_URLBLAZE}/product/currency-conversion-rate?fromCurrency=${defaultCurrency}&toCurrency=${currency}`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get exchange rate audit trail
    getExchangeSlabAuditTrail(currency:String,pageSize:number,pageNumber:number) {
      var url = "";
      var filter = "";
      if(currency != "" && currency != null){
        filter = filter+`&after%5B"to_currency"%5D=${currency}`
      }
      url = `${API_URLBLAZEOLD}/audit-trail?entity=currency_conversion_rate&page_size=${pageSize}&page_no=${pageNumber}&sort_dir=DESC&sort_column=eventTimestamp`+filter;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //review exchange rate slab
    reviewExchangeRateSlab(reviewData:any) {
      const url = `${API_URLBLAZE}/product/currency-conversion-rate`;
      return this.http.put(url,reviewData).pipe(catchError(this.handleError()));
    }


      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}